import {
  allIsFalse,
  DEFAULT_VALID,
  hasAtLastOneValue,
  requiredIsValid,
} from 'helpers/utils/ValidationUtils';

export interface CadastroPautaType {
  allIsValid: () => {
    error: boolean;
    helperText: string;
  };
  titlePauta: () => {
    error: boolean;
    helperText: string;
  };
  agency: () => {
    error: boolean;
    helperText: string;
  };
  nucleou: () => {
    error: boolean;
    helperText: string;
  };
  candidateOptions: () => {
    error: boolean;
    helperText: string;
  };
  electionCommissionOptions: () => {
    error: boolean;
    helperText: string;
  };
}

export const CadastroPautaValidator = (
  titlePauta: string,
  agency: string,
  nucleou: string,
  candidateOptions: any,
  electionCommissionOptions: any,
  typePauta: number
) => {
  const validator: any = {};

  validator.titlePauta = () => {
    const value = titlePauta;
    const required = requiredIsValid(value, 'Campo obrigatório');
    if (required.error) {
      return required;
    }
    return DEFAULT_VALID;
  };

  validator.candidateOptions = () => {
    const value: any = candidateOptions!;
    const required = hasAtLastOneValue(
      value!,
      1,
      'Ao menos adicione mais uma opção de voto'
    );

    if (required.error) {
      return required;
    }
    return DEFAULT_VALID;
  };

  validator.electionCommissionOptions = () => {
    const value: any = electionCommissionOptions!;

    const required = hasAtLastOneValue(
      value!,
      0,
      'Ao menos adicione um membro da comissão eleitoral'
    );

    if (typePauta === 1 && required.error) {
      return required;
    }
    return DEFAULT_VALID;
  };

  validator.agency = () => {
    const value = agency;

    const required = requiredIsValid(value, 'Campo obrigatório');

    if (typePauta === 2 && required.error) {
      return required;
    }
    return DEFAULT_VALID;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  validator.nucleou = () => {
    const value = nucleou;

    const required = requiredIsValid(value, 'Campo obrigatório');

    if (typePauta === 2 && required.error) {
      return required;
    }
    return DEFAULT_VALID;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  validator.allIsValid = () => {
    return allIsFalse([
      validator.titlePauta().error,
      validator.candidateOptions().error,
      validator.electionCommissionOptions().error,
      validator.agency().error,
      validator.nucleou().error,
    ]);
  };

  return validator;
};
